import { createContext, useState, useMemo } from 'react';

const AuthContext = createContext<any>({})

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState({})
  const value = useMemo(() => ({ auth, setAuth }), [auth, setAuth])

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  )
}

export default AuthContext
